import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchWorkers, getOutstandingWorkers, getLaborSummary, fetchRecentActivity } from '../../../../../../Redux/Projects/Labor/laborSlice';
import noLaborImage from '../../../../../../assets/illustration/labor-image.png';
import '../../../../../../Stylesheets/Dashboard/Tabs/Labor/Labor.css';
import AddLaborModal from './Component/AddLaborModal';
import WorkerProfileDrawer from './Component/WorkerProfileDrawer'
import MarkAttendanceModalBulk from './Component/MarkAttendanceModalBulk';
import LogPaymentFromDashboardModal from './Component/LogPaymentFromDashboardModal';
import MarkAttendanceModal from './Component/MarkAttendanceModal';
import LogPaymentModal from './Component/LogPaymentModal'
import { formatDate } from '../../../../../Utils/date';
import EmptyState from "../../../../../../Components/Common/EmptyState";

import { refreshLaborProject } from '../../../../../../Redux/Projects/Labor/laborSlice';
import LaborReportModal from './Component/LaborReportModal';
import axiosWithAuth from '../../../../../../Redux/UtilsRedux/axiosWithAuth';
import { API_ROUTES } from '../../../../../../Redux/Constants/apiRoutes';
import { showFeedback } from '../../../../../../Redux/UI/uiFeedbackSlice';

import { FaPlus, FaUserCheck, FaMoneyBillWave, FaSearch, FaSortAmountDown, FaClipboardList } from 'react-icons/fa';

const Labor = ({ currentProjectId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const [showReportModal, setShowReportModal] = useState(false);
  const [reportFrom, setReportFrom] = useState('');
  const [reportTo, setReportTo] = useState('');
  const [reportDetail, setReportDetail] = useState('summary'); // 'summary' | 'detailed'

  const [showModal, setShowModal] = useState(false);
  const [projectLabors, setProjectLabors] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [showAttendanceModalBulk, setShowAttendanceModalBulk] = useState(false);
  const [showLogPaymentModal, setShowLogPaymentModal] = useState(false);
  const [showIndividualMarkModal, setShowIndividualMarkModal] = useState(null); // worker object
  const [showIndividualPaymentModal, setShowIndividualPaymentModal] = useState(null); // worker object
  const [sortKey, setSortKey] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const { workers = [], loading } = useSelector(state => state.labor || {});
  const [showSortDropdown, setShowSortDropdown] = useState(false);


  // NEW: full boot loader gate
  const [initialLoad, setInitialLoad] = useState(true);

  const [outstandingSearch, setOutstandingSearch] = useState('');
  const [outstandingSortKey, setOutstandingSortKey] = useState('name'); // or 'amount'
  const [outstandingSortOrder, setOutstandingSortOrder] = useState('asc');
  const [outstandingPage, setOutstandingPage] = useState(1);
  const OUTSTANDING_PER_PAGE = 5;



  // outstanding
  const { list: outstandingWorkers = [], loadingOut } =
    useSelector(state => state.labor?.outstanding || {});
  const { totalWorkers, totalAttendance, outstandingAmount } = useSelector(
    (state) => state.labor.summary
  );
  const recentActivity = useSelector(state => state.labor?.recentActivity) || [];

  // ✅ Boot fetch: wait for all initial calls
  useEffect(() => {
    let alive = true;

    // IMPORTANT: if no project selected, don't keep loading forever
    if (!currentProjectId) {
      setInitialLoad(false);
      return;
    }

    setInitialLoad(true);

    (async () => {
      try {
        await dispatch(refreshLaborProject(currentProjectId)); // thunk returns a Promise
      } catch (e) {
        console.error('refreshLaborProject failed', e);
      } finally {
        if (!alive) return;
        setTimeout(() => alive && setInitialLoad(false), 250);
      }
    })();

    return () => { alive = false; };
  }, [currentProjectId, dispatch]);




  // ✅ FIXED: ripple listener (your current one leaks listeners)
  useEffect(() => {
    const onDocClick = (e) => {
      const btn = e.target.closest('.quick-btn-updated');
      if (!btn) return;
      const rect = btn.getBoundingClientRect();
      btn.style.setProperty('--x', `${e.clientX - rect.left}px`);
      btn.style.setProperty('--y', `${e.clientY - rect.top}px`);
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);



  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const notify = (type, title, message) =>
    dispatch(showFeedback({ type, title, message }));


  const filteredWorkers = workers.filter(
    w => String(w.projectId) === String(currentProjectId)
  );


  const [attendanceFetched, setAttendanceFetched] = useState(false);















  const searchedWorkers = filteredWorkers.filter(w =>
    `${w.firstName} ${w.lastName}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
    w.role.toLowerCase().includes(searchTerm.toLowerCase())
  );



  const sortedWorkers = [...searchedWorkers].sort((a, b) => {
    let valA = a[sortKey];
    let valB = b[sortKey];

    if (sortKey === 'name') {
      valA = `${a.firstName} ${a.lastName}`.toLowerCase();
      valB = `${b.firstName} ${b.lastName}`.toLowerCase();
    } else {
      valA = Number(valA || 0);
      valB = Number(valB || 0);
    }

    return sortOrder === 'asc' ? (valA > valB ? 1 : -1) : (valA < valB ? 1 : -1);
  });


  const workersPerPage = 4;
  const totalPages = Math.ceil(sortedWorkers.length / workersPerPage);

  const paginatedWorkers = sortedWorkers.slice(
    (currentPage - 1) * workersPerPage,
    currentPage * workersPerPage
  );





  const filteredOutstanding = outstandingWorkers.filter(worker =>
    `${worker.name}`.toLowerCase().includes(outstandingSearch.toLowerCase())
  );

  const sortedOutstanding = [...filteredOutstanding].sort((a, b) => {
    const valA = outstandingSortKey === 'amount' ? Number(a.outstanding) : a.name.toLowerCase();
    const valB = outstandingSortKey === 'amount' ? Number(b.outstanding) : b.name.toLowerCase();

    return outstandingSortOrder === 'asc' ? (valA > valB ? 1 : -1) : (valA < valB ? 1 : -1);
  });

  const paginatedOutstanding = sortedOutstanding.slice(
    (outstandingPage - 1) * OUTSTANDING_PER_PAGE,
    outstandingPage * OUTSTANDING_PER_PAGE
  );




  // ✅ HARD GATE: show loader first, nothing else
  if (initialLoad) {
    return (
      <div className="labor-boot-loading">
        <div className="labor-boot-loading-card">
          <div className="labor-spinner" />
          <p>Loading workers…</p>
        </div>
      </div>
    );
  }

  const showEmpty = !loading && filteredWorkers.length === 0;


  const handleExportLaborCSV = async () => {
    if (!currentProjectId) {
      notify('error', 'No project selected', 'Select a project before exporting.');
      return;
    }
    if (!reportFrom || !reportTo) {
      notify('error', 'Missing date range', 'Select a date range before exporting the report.');
      return;
    }

    const params = new URLSearchParams({
      type: 'labor',
      projectId: currentProjectId,
      from: reportFrom,
      to: reportTo,
      detail: reportDetail || 'summary',
      format: 'csv',
    }).toString();

    const url = `${API_ROUTES.PROJECT_REPORT}?${params}`;

    try {
      const res = await axiosWithAuth.get(url, { responseType: 'blob' });

      const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
      const href = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = href;
      link.download = `labor-report-${reportFrom}-to-${reportTo}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(href);

      notify('success', 'CSV exported', 'Labor report downloaded.');
    } catch (err) {
      console.error('Labor CSV export failed', err);
      notify(
        'error',
        'Export failed',
        err?.response?.data?.message || 'Failed to export labor CSV. Please try again.'
      );
    }
  };


  const handleExportLaborPDF = () => {
    if (!currentProjectId) {
      notify('error', 'No project selected', 'Select a project before exporting.');
      return;
    }
    if (!reportFrom || !reportTo) {
      notify('error', 'Missing date range', 'Select a date range before exporting the report.');
      return;
    }

    const params = new URLSearchParams({
      type: 'labor',
      projectId: currentProjectId,
      from: reportFrom,
      to: reportTo,
      detail: reportDetail || 'summary',
    }).toString();

    navigate(`/dashboard/labor-report-preview?${params}`, {
      state: { returnTo: `/dashboard/project/${currentProjectId}?tab=Labor` },
    });

    setShowReportModal(false);
    notify('info', 'Opening report', 'Generating preview…');
  };


  if (!currentProjectId) {
    return (
      <EmptyState
        variant="labor"
        icon={<FaPlus />}
        title="Select a project"
        subtitle="Choose a project to manage workers, attendance and payments."
        image={noLaborImage}
        imageAlt="Select project"
        ctaLabel="Go to Projects"
        onCta={() => navigate('/dashboard/projects')}
      />
    );
  }


  return (
    <div className="labor-section">
      {showEmpty ? (
        <EmptyState
          variant="labor"
          icon={<FaPlus />}
          title="No workers added yet"
          subtitle="Add your first worker to start attendance and payment tracking."
          image={noLaborImage}
          imageAlt="No labor"
          ctaLabel="Add Worker"
          onCta={() => setShowModal(true)}
        />
      ) : (
        <>
          {/* Metrics + Quick Actions */}
          <div className="labor-header-panel">
            <div className="metrics-box-updated compact">
              <div className="metric">
                <p>Total Workers</p>
                <h2>{totalWorkers}</h2>
              </div>
              <div className="metric-divider" />
              <div className="metric">
                <p>Total Attendance</p>
                <h2>{totalAttendance}</h2>
              </div>
              <div className="metric-divider" />
              <div className="metric">
                <p>Outstanding Amount</p>
                <h2>₹{outstandingAmount}</h2>
              </div>
            </div>


            {/* Quick Action button */}
            <div className="quick-actions-updated">
              <button className="quick-btn-updated" onClick={() => setShowModal(true)}>
                <FaPlus />
                <span>Add Worker</span>
              </button>
              <button className="quick-btn-updated" onClick={() => setShowAttendanceModalBulk(true)}>
                <FaUserCheck />
                <span>Mark Attendance</span>
              </button>
              <button className="quick-btn-updated" onClick={() => setShowLogPaymentModal(true)}>
                <FaMoneyBillWave />
                <span>Log Payment</span>
              </button>
              <button className="quick-btn-updated" onClick={() => setShowReportModal(true)}>
                <FaClipboardList />
                <span>View Report</span>
              </button>
            </div>
          </div>




          {/* Table or Card View */}
          <div className="labor-table-container">
            <div className="table-header">
              {isMobile ? (
                <>
                  {/* Mobile View */}
                  <div className="table-header-top">
                    <h3>All Workers</h3>
                    <span className="add-worker-link" onClick={() => setShowModal(true)}>
                      <FaPlus style={{ marginRight: '4px' }} />
                      Add Worker
                    </span>
                  </div>
                  <div className="search-sort-row">
                    <div className="search-wrapper">
                      <FaSearch style={{ marginRight: '8px', color: '#6b7280' }} />
                      <input
                        type="text"
                        placeholder="Search Worker"
                        className="search-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />

                    </div>
                    <button className="sort-btn icon" onClick={() => setShowSortDropdown(!showSortDropdown)}>
                      <FaSortAmountDown style={{ marginRight: '6px' }} />
                    </button>
                    {showSortDropdown && (
                      <div className="sort-dropdown-labor mobile">
                        {['name', 'wages', 'presentDays'].map(key => (
                          <div
                            key={key}
                            className="sort-option-labor"
                            onClick={() => {
                              setSortKey(key);
                              setSortOrder(prev => prev === 'asc' ? 'desc' : 'asc');
                              setShowSortDropdown(false);
                            }}
                          >
                            Sort by {key === 'presentDays' ? 'Present Days' : key.charAt(0).toUpperCase() + key.slice(1)} ({sortOrder === 'asc' ? '↑' : '↓'})
                          </div>
                        ))}
                      </div>
                    )}

                  </div>
                </>
              ) : (
                <>
                  {/* Desktop view */}
                  <h3>All Workers</h3>
                  <div className="search-wrapper-desktop">
                    <input
                      type="text"
                      placeholder="Search Worker"
                      className="search-input-desktop"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <FaSearch className="search-icon-inside" />
                  </div>


                  <div className="sort-dropdown-container">
                    <button
                      className="sort-toggle-btn"
                      onClick={() => setShowSortDropdown(prev => !prev)}
                    >
                      Sort By ({sortKey === 'wages' ? 'Wages' : sortKey === 'name' ? 'Name' : 'Present Days'}) {sortOrder === 'asc' ? '↑' : '↓'}
                    </button>

                    {showSortDropdown && (
                      <div className="sort-dropdown-labor">
                        {['name', 'wages', 'presentDays'].map(key => (
                          <div
                            key={key}
                            className="sort-option-labor"
                            onClick={() => {
                              setSortKey(key);
                              setSortOrder(prev => prev === 'asc' ? 'desc' : 'asc');
                              setShowSortDropdown(false);
                            }}
                          >
                            Sort by {key === 'presentDays' ? 'Present Days' : key.charAt(0).toUpperCase() + key.slice(1)} ({sortOrder === 'asc' ? '↑' : '↓'})
                          </div>
                        ))}
                      </div>
                    )}
                  </div>



                  <button className="labor-add-btn black" onClick={() => setShowModal(true)}>
                    + Add Worker
                  </button>
                </>
              )}
            </div>

            {isMobile ? (
              <div className="labor-card-container">

                {paginatedWorkers.length === 0 ? (
                  <p className="no-results-message">No workers found for the current filter.</p>
                ) : (
                  paginatedWorkers.map((lab, idx) => (
                    <div className="labor-card" key={idx}>
                      <div><strong>Name:</strong> {lab.firstName} {lab.lastName}</div>
                      <div><strong>Role:</strong> {lab.role}</div>
                      <div><strong>Wage/day:</strong> {lab.wages} Rs</div>
                      <div><strong>Present Days:</strong> {lab.presentDays || 0}</div>
                      <div><strong>Status:</strong> Active</div>
                      <div className="card-actions">
                        <button className="btn orange" onClick={() => setSelectedWorker(lab)}>View</button>
                        <button className="btn green" onClick={() => setShowIndividualMarkModal(lab)}>Mark</button>
                        <button
                          className="btn blue"
                          onClick={() =>
                            setShowIndividualPaymentModal({
                              _id: lab._id,
                              firstName: lab.firstName,
                              lastName: lab.lastName,
                            })}>Pay</button>
                      </div>
                    </div>
                  ))
                )}

                {totalPages > 1 && (
                  <div className="pagination-controls">
                    {Array.from({ length: totalPages }, (_, i) => (
                      <button
                        key={i}
                        className={`page-btn ${currentPage === i + 1 ? 'active' : ''}`}
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </button>
                    ))}
                  </div>
                )}

              </div>
            ) : (
              <>
                <table className="labor-table row-hoverable">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Role</th>
                      <th>Wage/day</th>
                      <th>Present Days</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>

                    {paginatedWorkers.length === 0 ? (
                      <p className="no-results-message">No workers found for the current filter.</p>
                    ) : (
                      paginatedWorkers.map((lab, idx) => (
                        <tr key={idx}>
                          <td>{lab.firstName} {lab.lastName}</td>
                          <td>{lab.role}</td>
                          <td>{lab.wages} Rs</td>
                          <td>{lab.presentDays || 0}</td>
                          <td>Active</td>
                          <td>
                            <button className="btn orange" onClick={() => setSelectedWorker(lab)}>View</button>
                            <button className="btn green" onClick={() => setShowIndividualMarkModal(lab)}>Mark</button>
                            <button className="btn blue"
                              onClick={() =>
                                setShowIndividualPaymentModal({
                                  _id: lab._id,
                                  firstName: lab.firstName,
                                  lastName: lab.lastName,
                                })
                              }>Pay</button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>



                </table>


                {totalPages > 1 && (
                  <div className="pagination-controls">
                    {Array.from({ length: totalPages }, (_, i) => (
                      <button
                        key={i}
                        className={`page-btn ${currentPage === i + 1 ? 'active' : ''}`}
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </button>
                    ))}
                  </div>
                )}

              </>
            )}


          </div>







          {/* Outstanding Payments + Recent Activity Section */}
          <div className="labor-extra-section">
            {/* OUTSTANDING PAYMENTS */}
            <div className="outstanding-section">
              <div className="outstanding-header-top">

                {/* Optional Sort */}
                {!isMobile ? (
                  <div className="outstanding-header">
                    <h3>Outstanding Payments</h3>
                    <div className="outstanding-controls">
                      <input
                        type="text"
                        placeholder="Search by name"
                        value={outstandingSearch}
                        onChange={(e) => {
                          setOutstandingSearch(e.target.value);
                          setOutstandingPage(1); // reset to page 1
                        }}
                      />

                      <select
                        value={outstandingSortKey}
                        onChange={(e) => setOutstandingSortKey(e.target.value)}
                      >
                        <option value="name">Sort by Name</option>
                        <option value="amount">Sort by Amount</option>
                      </select>

                      <select
                        value={outstandingSortOrder}
                        onChange={(e) => setOutstandingSortOrder(e.target.value)}
                      >
                        <option value="asc">Ascending</option>
                        <option value="desc">Descending</option>
                      </select>
                    </div>
                  </div>
                ) : (
                  <div className="outstanding-header-mob">
                    <h3>Outstanding Payments</h3>
                    <div className="outstanding-mobile-header">
                      <div className="mobile-search-wrapper">
                        <input
                          type="text"
                          placeholder="Search by name"
                          value={outstandingSearch}
                          onChange={(e) => {
                            setOutstandingSearch(e.target.value);
                            setOutstandingPage(1);
                          }}
                        />
                      </div>
                      <div className="mobile-sort-wrapper">
                        <select
                          value={outstandingSortKey}
                          onChange={(e) => setOutstandingSortKey(e.target.value)}
                        >
                          <option value="name">Sort by Name</option>
                          <option value="amount">Sort by Amount</option>
                        </select>

                        <select
                          value={outstandingSortOrder}
                          onChange={(e) => setOutstandingSortOrder(e.target.value)}
                        >
                          <option value="asc">Ascending</option>
                          <option value="desc">Descending</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {isMobile ? (
                <>




                  {paginatedOutstanding.length === 0 ? (
                    <tr><td colSpan="3">No results found</td></tr>
                  ) : (
                    paginatedOutstanding.map(worker => (
                      <div className="labor-card">
                        <div><strong>Name:</strong> {worker.name}</div>
                        <div><strong>Outstanding:</strong> Rs {worker.outstanding}</div>
                        <div><strong>Last Paid:</strong> {worker.lastPaid ? formatDate(worker.lastPaid) : 'N/A'}</div>
                        <div className="card-actions">
                          <button
                            className="btn blue"
                            onClick={() => {
                              setShowIndividualPaymentModal({
                                _id: worker.workerId,
                                firstName: worker.name?.split(' ')[0] || 'Worker',
                                lastName: worker.name?.split(' ')[1] || '',
                              })
                            }}
                          >

                            Log Payment
                          </button>
                        </div>
                      </div>
                    ))
                  )}


                  <div className="pagination">
                    <button disabled={outstandingPage === 1} onClick={() => setOutstandingPage(p => p - 1)}>Prev</button>
                    <span>{outstandingPage} / {Math.ceil(sortedOutstanding.length / OUTSTANDING_PER_PAGE)}</span>
                    <button
                      disabled={outstandingPage === Math.ceil(sortedOutstanding.length / OUTSTANDING_PER_PAGE)}
                      onClick={() => setOutstandingPage(p => p + 1)}
                    >
                      Next
                    </button>
                  </div>



                </>
              ) : (
                <>
                  <table className="labor-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Outstanding</th>
                        <th>Last Paid</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedOutstanding.length === 0 ? (
                        <tr><td colSpan="3">No results found</td></tr>
                      ) : (
                        paginatedOutstanding.map((worker) => (
                          <tr key={worker.workerId}>
                            <td>{worker.name}</td>
                            <td>Rs {worker.outstanding}</td>
                            <td>{worker.lastPaid ? formatDate(worker.lastPaid) : 'N/A'}</td>
                            <td>
                              <button
                                className="btn blue"
                                onClick={() =>
                                  setShowIndividualPaymentModal({
                                    _id: worker.workerId,
                                    firstName: worker.name?.split(' ')[0] || 'Worker',
                                    lastName: worker.name?.split(' ')[1] || '',
                                  })
                                }
                              >
                                Log Payment
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>

                  <div className="pagination">
                    <button disabled={outstandingPage === 1} onClick={() => setOutstandingPage(p => p - 1)}>Prev</button>
                    <span>{outstandingPage} / {Math.max(1, Math.ceil(sortedOutstanding.length / OUTSTANDING_PER_PAGE))}</span>
                    <button
                      disabled={outstandingPage === Math.ceil(sortedOutstanding.length / OUTSTANDING_PER_PAGE) || sortedOutstanding.length === 0}
                      onClick={() => setOutstandingPage(p => p + 1)}
                    >
                      Next
                    </button>
                  </div>

                </>

              )}
            </div>

            {/* RECENT ACTIVITY (Keep as cards always) */}
            <div className="recent-activity-section">
              <h3>Recent Activity</h3>
              <div className="activity-cards">
                <div className="activity-cards">
                  {!recentActivity || recentActivity.length === 0 ? (
                    <p>No recent activity</p>
                  ) : (
                    recentActivity.map((log, idx) => {
                      const when = log.date || log.createdAt || log.updatedAt || log.timestamp;

                      return (
                        <div className="activity-card" key={log._id || idx}>
                          <p><strong>{log.message}</strong></p>
                          <p>Date: {when ? new Date(when).toLocaleString() : '—'}</p>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>




        </>
      )}

      {showModal && (
        <AddLaborModal
          onClose={() => setShowModal(false)}
          currentProjectId={currentProjectId}
        />
      )}


      {selectedWorker && (
        <WorkerProfileDrawer
          worker={selectedWorker}
          onClose={() => setSelectedWorker(null)}
        />
      )}


      {showAttendanceModalBulk && (
        <MarkAttendanceModalBulk
          projectId={currentProjectId}
          onClose={() => setShowAttendanceModalBulk(false)}
          onSubmit={(attendanceData) => {
            console.log('Submitted Attendance:', attendanceData);
            setShowAttendanceModalBulk(false);
            // TODO: Save attendanceData in localStorage by date
          }}
        />
      )}


      {showLogPaymentModal && (
        <LogPaymentFromDashboardModal
          projectId={currentProjectId}
          onClose={() => setShowLogPaymentModal(false)}
          onSubmit={(entry) => {
            console.log('Logged Payment:', entry);
            // Optionally store in localStorage or Redux
            setShowLogPaymentModal(false);
          }}
        />
      )}


      {showIndividualMarkModal && (
        <MarkAttendanceModal
          workerId={showIndividualMarkModal._id}
          workerName={`${showIndividualMarkModal.firstName} ${showIndividualMarkModal.lastName}`}
          onClose={() => setShowIndividualMarkModal(null)}
        />
      )}

      {showIndividualPaymentModal && (
        <LogPaymentModal
          worker={showIndividualPaymentModal}
          onClose={() => setShowIndividualPaymentModal(null)}
          onSubmit={(paymentEntry) => {
            console.log("Logged individual payment", paymentEntry);
            setShowIndividualPaymentModal(null);
          }}
        />
      )}


      {showReportModal && (
        <LaborReportModal
          show={showReportModal}
          onClose={() => setShowReportModal(false)}
          startDate={reportFrom}
          endDate={reportTo}
          setStartDate={setReportFrom}
          setEndDate={setReportTo}
          format={reportDetail}
          setFormat={setReportDetail}
          handleExportCSV={handleExportLaborCSV}
          handleExportPDF={handleExportLaborPDF}
        />
      )}





    </div>
  );
};

export default Labor;
